export const isIOS = () => {
  if (typeof window === "undefined") return false;
  return /iphone|ipad|ipod/i.test(window.navigator.userAgent);
};

export const isAndroid = () => {
  if (typeof window === "undefined") return false;
  return /android/i.test(window.navigator.userAgent);
};

export const isDesktop = () => {
  if (typeof window === "undefined") return false;
  return !isIOS() && !isAndroid();
};
